// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"43f2d82a","419":"9a0aaa78"}[chunkId] + ".chunk.js";
};